import {HttpClient} from "@/requestHandler";
import {materialWithCarbonQuery} from "@/qwebApiQueries";
import {
  createMaterialMutation,
  updateMaterialCarbonCharacteristicMutation,
  updateMaterialMutation
} from "@/qwebApiMutations";

const normalizeMaterialInput = (material) => ({
  model      : material.model ?? material.materiel_modele ?? material.materiel?.modele ?? "",
  description: material.description ?? material.materiel_description ?? material.materiel?.description ?? "",
  company    : material.company ?? material.materiel_compagnie ?? material.materiel?.compagnie ?? "",
  address    : material.address ?? material.materiel_adresse1 ?? material.materiel?.adresse1 ?? "",
  density    : Number(material.density ?? material.tech_densite ?? material.tech?.densite ?? 0),
  thickness  : Number(material.thickness ?? material.tech_epaisseur ?? material.tech?.epaisseur ?? 0),
  rValue     : String(material.rValue ?? material.tech_rValue ?? material.tech?.rValue ?? ""),
  nails      : String(material.nails ?? material.tech_nails ?? material.tech?.nails ?? "")
});

const normalizeMaterialCarbonInput = (material, materialId) => ({
  materialId            : String(materialId ?? material.materialId ?? material._id ?? ""),
  validity              : Boolean(material.validity ?? material.validation ?? false),
  type                  : String(material.type ?? material.epd_type ?? ""),
  expiration            : material.expiration ?? material.epd_expiration ?? null,
  lifeCycle             : String(material.lifeCycle ?? material.epd_cycleDeVie ?? ""),
  database              : String(material.database ?? material.epd_baseDeDonnee ?? ""),
  impactCharacteristics : String(material.impactCharacteristics ?? material.epd_caracteristiqueDeImpact ?? ""),
  url                   : String(material.url ?? material.epd_url ?? ""),
  pcr                   : String(material.pcr ?? material.epd_pcr ?? ""),
  woodHumidity          : Number(material.woodHumidity ?? material.tech_humiditeBois ?? 0),
  a1a3                  : Number(material.a1a3 ?? material.resultat_a1a3 ?? 0),
  a4                    : Number(material.a4 ?? material.resultat_a4 ?? 0),
  a5                    : Number(material.a5 ?? material.resultat_a5 ?? 0),
  b1b7                  : Number(material.b1b7 ?? material.resultat_b1b7 ?? 0),
  c2                    : Number(material.c2 ?? material.resultat_c2 ?? 0),
  c4                    : Number(material.c4 ?? material.resultat_c4 ?? 0),
  total                 : Number(material.total ?? material.resultat_total ?? 0)
});

export const qwebApi = {
  state    : () => ({
    materials: [],
  }),
  getters  : { },
  mutations: {
    addMaterial(state, payload) {
      state.materials.push(payload.material);
    },
  },
  actions  : {
    async retrieveMaterials({state}) {
      const client = new HttpClient(process.env.VUE_APP_QWEBAPI_URL);
      const query = materialWithCarbonQuery();
      const response = await client.post('', {query});
      state.materials = response.data.materials ?? [];
    },
    async createMaterial({commit}, payload) {
      const material = normalizeMaterialInput(payload.material);
      const client = new HttpClient(process.env.VUE_APP_QWEBAPI_URL);
      const query = createMaterialMutation(material);
      const response = await client.post('', query);
      const createdMaterial = response.data.createMaterial;
      const characteristics = normalizeMaterialCarbonInput(payload.material, createdMaterial?._id);
      if (characteristics.materialId) {
        const carbonQuery = updateMaterialCarbonCharacteristicMutation(characteristics);
        await client.post('', carbonQuery);
      }

      commit('addMaterial', {
        material: {
          ...createdMaterial,
          materialCarbonCharacteristics: characteristics
        }
      });
    },
    async updateMaterial(context, payload) {
      const material = normalizeMaterialInput(payload.material);
      const characteristics = normalizeMaterialCarbonInput(payload.material, payload.id);
      const client = new HttpClient(process.env.VUE_APP_QWEBAPI_URL);
      const query = updateMaterialMutation(payload.id, material);
      await client.post('', query);
      const carbonQuery = updateMaterialCarbonCharacteristicMutation(characteristics);
      await client.post('', carbonQuery);
    },
  }
}
